import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["highlightColor", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* eslint-disable @typescript-eslint/no-unused-vars */

var IconReactionPositiveSmall = function IconReactionPositiveSmall(_ref) {
  _ref.highlightColor;
    var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({
    width: size,
    height: size
  }, newProps), {}, {
    className: classNames('sol-icon', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-reaction-positive-small"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88324 2.20147C9.03946 2.07129 9.23637 2 9.43971 2C9.98824 2 10.3996 2.50183 10.2921 3.03971L9.90001 5.00001L13 5C13.5523 5 14 5.44772 14 6V8.0934C14 8.59595 13.8108 9.08008 13.4701 9.44947L10.4918 12.678C10.3025 12.8833 10.036 13 9.75681 13L6 13C5.44772 13 5 12.5523 5 12L5 8.18751V5.90588C5 5.6091 5.13182 5.32765 5.35982 5.13766L8.88324 2.20147ZM2.5 6C2.22386 6 2 6.22386 2 6.5V12.5C2 12.7761 2.22386 13 2.5 13H3.5C3.77614 13 4 12.7761 4 12.5V6.5C4 6.22386 3.77614 6 3.5 6H2.5Z",
    fill: "currentColor"
  })));
};

export { IconReactionPositiveSmall };
